import { type StaticColor } from '@/features/shared/theme/staticColors'
import { type BadgeType } from '@/features/shared/elements/Badges/types'

export const badgeStyle: Record<
  BadgeType,
  { badgeCopy: string; color: StaticColor; bgColor: StaticColor }
> = {
  buyAgain: {
    badgeCopy: 'Buy Again',
    color: 'plum',
    bgColor: 'yellow500',
  },
  lowStock: {
    badgeCopy: 'Low stock',
    color: 'plum',
    bgColor: 'blue100',
  },
  oos: {
    badgeCopy: 'Out of stock',
    color: 'plum',
    bgColor: 'gray300',
  },
  limit: {
    badgeCopy: 'Limit: ',
    color: 'plum',
    bgColor: 'blue100',
  },
  forYou: {
    badgeCopy: 'For you',
    color: 'white',
    bgColor: 'purple500',
  },
  memberOnlyPromo: {
    badgeCopy: 'Members only',
    color: 'plum',
    bgColor: 'purple100',
  },
  snapEbtEligible: {
    badgeCopy: 'EBT eligible',
    color: 'white',
    bgColor: 'dark_green',
  },
  justForYou: {
    badgeCopy: 'Just for you',
    color: 'gray900',
    bgColor: 'lime',
  },
  accent_loud: {
    badgeCopy: '',
    color: 'gray900',
    bgColor: 'lime',
  },
  buyAgainV2: {
    badgeCopy: 'Buy Again',
    color: 'buyAgainColor',
    bgColor: 'buyAgainBgColor',
  },
  warning: {
    badgeCopy: 'Low stock',
    color: 'warningColor',
    bgColor: 'warningBgColor',
  },
  negative: {
    badgeCopy: 'Out of stock',
    color: 'primaryContrast',
    bgColor: 'negativeBgColor',
  },
  limitV2: {
    badgeCopy: 'Limit: ',
    color: 'informationalColor',
    bgColor: 'informationalBgColor',
  },
  informational: {
    badgeCopy: 'For you',
    color: 'informationalColor',
    bgColor: 'informationalBgColor',
  },
  sponsored: {
    badgeCopy: 'Sponsored',
    color: 'plum',
    bgColor: 'white',
  },
}
